import React from 'react'
import { Box } from '@mui/material'

const SpaceTheme = ({ children }) => {
  return (
    <Box sx={{ 
      flexGrow: 1, 
      position: 'relative',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0c0c0c 0%, #1a1a2e 25%, #16213e 50%, #0f3460 75%, #533483 100%)',
      overflow: 'hidden'
    }}>
      {/* Animated Stars Background */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        zIndex: 0
      }}>
        {/* Large Stars */}
        {[...Array(20)].map((_, i) => (
          <Box
            key={`star-${i}`}
            sx={{
              position: 'absolute',
              width: '2px',
              height: '2px',
              backgroundColor: '#ffffff',
              borderRadius: '50%',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `twinkle ${3 + Math.random() * 4}s infinite ease-in-out`,
              animationDelay: `${Math.random() * 3}s`,
              '@keyframes twinkle': {
                '0%, 100%': { opacity: 0.3, transform: 'scale(1)' },
                '50%': { opacity: 1, transform: 'scale(1.5)' }
              }
            }}
          />
        ))}
        
        {/* Medium Stars */}
        {[...Array(15)].map((_, i) => (
          <Box
            key={`medium-star-${i}`}
            sx={{
              position: 'absolute',
              width: '3px',
              height: '3px',
              backgroundColor: '#87ceeb',
              borderRadius: '50%',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `twinkle ${4 + Math.random() * 3}s infinite ease-in-out`,
              animationDelay: `${Math.random() * 4}s`,
              '@keyframes twinkle': {
                '0%, 100%': { opacity: 0.2, transform: 'scale(1)' },
                '50%': { opacity: 0.8, transform: 'scale(1.3)' }
              }
            }}
          />
        ))}
        
        {/* Small Stars */}
        {[...Array(30)].map((_, i) => (
          <Box
            key={`small-star-${i}`}
            sx={{
              position: 'absolute',
              width: '1px',
              height: '1px',
              backgroundColor: '#ffffff',
              borderRadius: '50%',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `twinkle ${2 + Math.random() * 2}s infinite ease-in-out`,
              animationDelay: `${Math.random() * 2}s`,
              '@keyframes twinkle': {
                '0%, 100%': { opacity: 0.1, transform: 'scale(1)' },
                '50%': { opacity: 0.6, transform: 'scale(1.2)' }
              }
            }}
          />
        ))}
        
        {/* Floating Orbs */}
        {[...Array(5)].map((_, i) => (
          <Box
            key={`orb-${i}`}
            sx={{
              position: 'absolute',
              width: `${20 + Math.random() * 40}px`,
              height: `${20 + Math.random() * 40}px`,
              background: `radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 50%, transparent 100%)`,
              borderRadius: '50%',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `float ${8 + Math.random() * 4}s infinite ease-in-out`,
              animationDelay: `${Math.random() * 5}s`,
              '@keyframes float': {
                '0%, 100%': { transform: 'translateY(0px) rotate(0deg)' },
                '50%': { transform: 'translateY(-20px) rotate(180deg)' }
              }
            }}
          />
        ))}
      </Box>

      {/* Content Container */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        {children}
      </Box>
    </Box>
  )
}

export default SpaceTheme
